import React from 'react';
import styles from './TestCase.module.css';

/**
 * TestCase — muestra una fila de caso de prueba con input, expected y resultado.
 *
 * @param {string}  inputLabel    - Texto que representa el input
 * @param {string}  expectedLabel - Texto que representa el resultado esperado
 * @param {string}  actualLabel   - Texto que representa el resultado obtenido
 * @param {boolean} pass          - Si el caso pasó o falló
 */
function TestCase({ inputLabel, expectedLabel, actualLabel, pass }) {
  return (
    <div className={styles.row}>
      <span className={styles.input}>{inputLabel}</span>
      <span className={styles.arrow}>→</span>
      <span className={styles.expected}>{expectedLabel}</span>
      <span className={`${styles.actual} ${pass ? styles.pass : styles.fail}`}>
        {pass ? '✓' : '✗'} {actualLabel}
      </span>
    </div>
  );
}

export default TestCase;
